
import { useNavigate } from "react-router-dom";
import IMAGE_1 from "../web_core/images/barra.jpeg";
import IMAGE_2 from "../web_core/images/bilal.jpeg";
import IMAGE_3 from "../web_core/images/ijaz.jpeg";





export const instructors = [
  {
    id: 1,
    name: "Qari Barra Abbasi",
    language: "English/Urdu",
    exp: "3 years",
    image: IMAGE_1,
  },
  {
    id: 2,
    name: "Hafiz Bilal Asif",
    language: "English/Urdu",
    exp: "6 years",
    image: IMAGE_2,
  },
  {
    id: 3,
    name: "Qari Ijaz Farooq",
    language: "English/Urdu",
    exp: "4 years",
    image: IMAGE_3,
  },
];

const InstructorSection = () => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/scholar/${id}`);
  };

  return (
    <section style={{ padding: "60px 20px", background: "#f8fafc" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

        <h2
          style={{
            textAlign: "center",
            marginBottom: "50px",
            fontSize: "42px",
            color: "#1e293b",
            fontWeight: "700"
          }}
        >
          Our Instructors
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px,1fr))",
            gap: "25px"
          }}
        >
          {instructors.map(({ id, name, language, exp, image }) => (
            <div
              key={id}
              onClick={() => handleClick(id)}
              style={{
                position: "relative",
                cursor: "pointer",
                overflow: "hidden",
                borderRadius: "12px"
              }}
            >
              <img
                src={image}
                alt={name}
                style={{
                  width: "100%",
                  height: "380px",
                  objectFit: "cover",
                  display: "block",
                  transition: "transform 0.3s"
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              />

              {/* Overlay Info Button */}
              <button
                style={{
                  position: "absolute",
                  bottom: "18px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "white",
                  border: "none",
                  color: "#1e293b",
                  padding: "6px 16px",
                  borderRadius: "25px",
                  fontSize: "12px",
                  fontWeight: "600",
                  boxShadow: "0 3px 10px rgba(0,0,0,0.2)"
                }}
              >
                {name} • {exp} • {language}
              </button>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default InstructorSection;
